import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "zone", "fileName", "fileInfo", "submit"]

  connect() {
    this.updateDisplay()
  }

  selectFile() {
    this.inputTarget.click()
  }

  handleFileSelect(event) {
    this.updateDisplay()
  }

  handleDragOver(event) {
    event.preventDefault()
    this.zoneTarget.style.borderColor = '#33A036'
    this.zoneTarget.style.background = '#d4edda'
  }

  handleDragLeave(event) {
    event.preventDefault()
    this.zoneTarget.style.borderColor = '#dee2e6'
    this.zoneTarget.style.background = '#f8f9fa'
  }

  handleDrop(event) {
    event.preventDefault()
    this.zoneTarget.style.borderColor = '#dee2e6'
    this.zoneTarget.style.background = '#f8f9fa'

    if (event.dataTransfer.files.length) {
      this.inputTarget.files = event.dataTransfer.files
      this.updateDisplay()
    }
  }

  updateDisplay() {
    if (this.inputTarget.files.length > 0) {
      const file = this.inputTarget.files[0]
      this.fileNameTarget.textContent = file.name
      this.fileInfoTarget.classList.remove('d-none')
      this.submitTarget.disabled = false
    } else {
      this.fileInfoTarget.classList.add('d-none')
      this.submitTarget.disabled = true
    }
  }
}
